import { render, staticRenderFns } from "./WaitingList-List.vue?vue&type=template&id=ac311722&"
import script from "./WaitingList-List.js?vue&type=script&lang=js&"
export * from "./WaitingList-List.js?vue&type=script&lang=js&"
import style0 from "./WaitingList-List.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports